// @flow

import { createStore, applyMiddleware, compose } from "redux"
import { routerMiddleware } from "react-router-redux"
import { persistStore, autoRehydrate } from "redux-persist"
import thunk from "redux-thunk"
import createHistory from "history/createBrowserHistory"
import rootReducer from "./reducers"

export const history = createHistory()

const initialState = {
  auth: {
    token: "",
    message: "",
    ok: false,
  },
}
const enhancers = [ autoRehydrate() ]
const middleware = [ thunk, routerMiddleware( history ) ]


const cc = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const composedEnhancers = cc(
  applyMiddleware( ...middleware ),
  ...enhancers
)

const store = createStore(
  rootReducer,
  initialState,
  composedEnhancers
)

persistStore( store, {
  whitelist: [ "auth" ],
} )

export default store



// WEBPACK FOOTER //
// ./src/store.jsx